import { render, staticRenderFns } from "./AddProfilCompanyPage.vue?vue&type=template&id=b9603ee8&"
import script from "./AddProfilCompanyPage.vue?vue&type=script&lang=js&"
export * from "./AddProfilCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9603ee8')) {
      api.createRecord('b9603ee8', component.options)
    } else {
      api.reload('b9603ee8', component.options)
    }
    module.hot.accept("./AddProfilCompanyPage.vue?vue&type=template&id=b9603ee8&", function () {
      api.rerender('b9603ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AddProfilCompanyPage.vue"
export default component.exports